import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=64ef092c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=64ef092c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef092c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ef092c')) {
      api.createRecord('64ef092c', component.options)
    } else {
      api.reload('64ef092c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=64ef092c&scoped=true&", function () {
      api.rerender('64ef092c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22itpyHuXCIkA/JS/comp/SearchFilterTokens.vue"
export default component.exports